import { useState } from 'react';
import { Box, Typography, Button, Grid, Collapse } from '@mui/material';
import COLORS from '../../../../../../constants/colors';
import { FaPlus, FaMinus } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { PrimaryButton } from '../../../../../Reusable/Button';

const faqs = [
    { 
        question: 'How do I start a fundraiser on Yamba Africa?', 
        answer: 'oin our supportive community by creating an account, providing your details, and uploading your National ID to ensure trust and transparency in every fundraiser'
    },
    { 
        question: 'What types of causes can I raise money for?', 
        answer: 'Our community stands behind all causes that uplift lives, except politically driven campaigns, ensuring a safe, inclusive space for fundraising that truly makes a difference'
    },
    { 
        question: 'How does Yamba Africa ensure the security of my funds?', 
        answer: 'We prioritize our community’s trust by using advanced encryption and secure payment processing, ensuring that every donation reaches its intended purpose safely and transparently'
    },
    { 
        question: 'What payment methods are accepted for donations?', 
        answer: 'We make giving easy and accessible for our community by supporting Airtel Money, MTN Mobile Money, and credit cards, ensuring donations are simple and seamless for everyone.'
    },
    { 
        question: 'Are there any fees associated with creating or donating to a fundraiser?', 
        answer: 'Creating and donating are free! A small 4.25% processing fee keeps our platform secure, enabling us to serve the community with reliable and safe transactions.'
    },
    { 
        question: 'How can I withdraw the funds raised?', 
        answer: 'Our community-driven platform ensures smooth withdrawals to your mobile money or bank account, with a verification process taking at most an hour to maintain security and trust.'
    },
    { 
        question: 'Can I run multiple fundraisers simultaneously?', 
        answer: 'Yes! Our community thrives on shared support, so you can run multiple fundraisers at once, helping different causes and bringing people together for greater impact.'
    },
    { 
        question: 'How does Yamba Africa support fundraisers in promoting their campaigns?', 
        answer: 'We amplify your campaign through our engaged community, social media platforms, and 100 free messages to Airtel/MTN contacts, ensuring your story reaches those who care.'
    },
    { 
        question: 'How do I know if my donation was successful?', 
        answer: 'After donating, you will receive a confirmation email and a transaction receipt. You can also check your donation history in your account dashboard.'
    },
    { 
        question: 'Is there a verification process for fundraisers?', 
        answer: 'To protect our community, fundraisers must provide a National ID that matches their name and withdrawal details, ensuring every campaign is trustworthy and accountable. Yamba Africa also reserves the right to verify fundraisers through additional means if necessary, maintaining a safe and reliable platform for all users.'
    },
    { 
        question: 'How does Yamba Africa handle donor privacy and data protection?', 
        answer: 'Yamba Africa is commited to protecting the Data Privacy Act of Uganda, and the global commitments like GDPR. We use advanced encryption and secure servers to safeguard your personal information, ensuring that your data is protected and used responsibly.'
    },
    { 
        question: 'How can I contact support?', 
        answer: 'If you need assistance, you can reach our support team via email, live chat, or the contact form on our website. We are here to help!'
    }
];


const FAQs = () => {
    const [openIndex, setOpenIndex] = useState(null);

    const handleToggle = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <Box sx={{ textAlign: 'left', py: 10, px: 3, maxWidth: 900, margin: '0 auto' }}>
            <Typography variant="h4" fontWeight="bold" color={COLORS.primary} mb={6} textAlign="center">
                Frequently Asked Questions
            </Typography>

            <Grid container spacing={4}>
                {faqs.map((faq, index) => (
                    <Grid item xs={12} key={index}>
                        <Box
                            sx={{
                                backgroundColor: '#f9f9f9',
                                borderRadius: '12px',
                                padding: '16px',
                                boxShadow: '0px 6px 12px rgba(0, 0, 0, 0.02)',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease',
                                '&:hover': { backgroundColor: '#f1f1f1' }
                            }}
                            onClick={() => handleToggle(index)}
                        >
                            <Box display="flex" justifyContent="space-between" alignItems="center">
                                <Typography variant="h6" fontWeight="bold" color={COLORS.primary} sx={{fontSize:'1rem'}}>
                                    {faq.question}
                                </Typography>
                                {openIndex === index ? <FaMinus color={COLORS.primary} /> : <FaPlus color={COLORS.primary} />}
                            </Box>
                            <Collapse in={openIndex === index} timeout="auto" unmountOnExit>
                                <Typography variant="body1" color="#555" mt={2}>
                                    {faq.answer}
                                </Typography>
                            </Collapse>
                        </Box>
                    </Grid>
                ))}
            </Grid>

            <Box display="flex" justifyContent="flex-end" mt={5}>
                <PrimaryButton component={Link}
                    to="/contact-us" >
                    Still have questions? Contact Us
                </PrimaryButton>
                
            </Box>
        </Box>
    );
};

export default FAQs;